/** Helpers de formato compartidos por los tabs de Analytics Difare. */

export const nf = (n: number) => n.toLocaleString('es-EC')

/** "CARMITA REYES" / "carmita reyes" -> "Carmita Reyes". No muta datos; solo presentación. */
export function toTitleCase(s: string): string {
  return (s ?? '')
    .toLocaleLowerCase('es')
    .replace(/\b[\p{L}]/gu, (c) => c.toLocaleUpperCase('es'))
}

const MESES = ['ene', 'feb', 'mar', 'abr', 'may', 'jun', 'jul', 'ago', 'sep', 'oct', 'nov', 'dic']

/** "2026-10-25" -> "25 oct". */
export function fechaCorta(iso: string): string {
  const [y, m, d] = (iso ?? '').split('-').map(Number)
  if (!y || !m || !d) return iso
  return `${d} ${MESES[m - 1] ?? ''}`
}
